module.exports = "/wp-content/plugins/farmacy/assets/js/fonts/glyphicons-halflings-regular-fa2772327f55d8198301fdb8bcfc8158.woff";


/*****************
 ** WEBPACK FOOTER
 ** ./assets/scss/fonts/bootstrap/glyphicons-halflings-regular.woff
 ** module id = 229
 ** module chunks = 1 2 6 7 12 23 42 48 62
 **/